import { approveDriver, rejectDriver, approveVehicle, rejectVehicle } from 'store/approvalSliceV2';

const EMPTY = '-';

const yesNo = (value) => {
	if (value === true) return 'Yes';
	if (value === false) return 'No';
	return EMPTY;
};

/**
 * Per-kind settings shared by the Driver Approval and Vehicle Approval screens.
 * `fields` turns an approval's entity_summary into the label/value pairs shown on the
 * card, the table and the details page, so the three always agree.
 */
export const VERIFICATION_KINDS = {
	driver: {
		kind: 'driver',
		noun: 'Driver',
		approvalType: 'driver_verification',
		listPath: '/approvals/driver',
		title: 'Driver Approvals',
		subtitle: 'Verify the documents of newly onboarded drivers',
		aclModule: 'handle_driver_approval',
		approve: approveDriver,
		reject: rejectDriver,
		fields: (summary = {}) => [
			{ key: 'driver_name', label: 'Driver Name', value: summary.driver_name || EMPTY },
			{ key: 'phone_number', label: 'Phone Number', value: summary.phone_number || EMPTY },
			{ key: 'vendor_name', label: 'Vendor Name', value: summary.vendor_name || EMPTY },
		],
	},
	vehicle: {
		kind: 'vehicle',
		noun: 'Vehicle',
		approvalType: 'vehicle_verification',
		listPath: '/approvals/vehicle',
		title: 'Vehicle Approvals',
		subtitle: 'Verify the documents of newly onboarded vehicles',
		aclModule: 'handle_vehicle_approval',
		approve: approveVehicle,
		reject: rejectVehicle,
		fields: (summary = {}) => [
			{
				key: 'vehicle_number',
				label: 'Vehicle Number',
				value: summary.vehicle_number || EMPTY,
			},
			{ key: 'vendor_name', label: 'Vendor Name', value: summary.vendor_name || EMPTY },
			{ key: 'gps_installed', label: 'GPS Installed', value: yesNo(summary.gps_installed) },
			{ key: 'gps_provider', label: 'GPS Provider', value: summary.gps_provider || EMPTY },
		],
	},
};

export const VERIFICATION_STATUS_COLORS = {
	pending: 'gold',
	approved: 'green',
	verified: 'green',
	rejected: 'red',
};
